import styled from 'styled-components';
import { black, white } from '@avangard/ui/colors';
import { capitalizeFirstLetter } from '@avangard/utils/formatters';

import { useCurrentUser } from '@modules/user/hooks';
import { ChatMessageEntity } from '@modules/chat/entities';

type ChatsMessageItemProps = {
    message: ChatMessageEntity;
};

const ChatsMessageItem = (props: ChatsMessageItemProps) => {
    const { message } = props;

    const { currentUser } = useCurrentUser();

    const isSender = message.isSender(currentUser.id);

    return (
        <Root sender={isSender}>
            {!isSender ? <Header>{capitalizeFirstLetter(message.getSenderTitle())}</Header> : null}
            <Content>{message.message}</Content>
            <Footer>{message.getCreatedAtTime()}</Footer>
        </Root>
    );
};

const Header = styled.div`
    padding: 0 8px;

    color: ${black[80]};
    font-size: 1.2rem;

    span {
        color: ${black[54]};
    }
`;

const Content = styled.div`
    max-width: 320px;
    width: 100%;

    margin: 6px 0;
    padding: 12px;

    color: ${black[80]};
    font-size: 1.4rem;

    background-color: ${white[50]};
    border-radius: 8px;
`;

const Footer = styled.div`
    padding: 0 8px;

    font-size: 1.2rem;
    color: ${black[54]};
`;

const Root = styled.div<{ sender?: boolean }>`
    ${p =>
        p.sender &&
        `
            ${Content} {
                margin-left: auto;
                background-color: rgb(33 150 243 / 15%);
            }

            ${Footer} {
               text-align: right;
            }
        `}
`;

export { ChatsMessageItem };
